import { SurveyCard, Loading, SurveyLayout, ErrorMessage, TokenAuth } from '@/components';
import { Pagination } from '@heroui/react';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import { useLogout, usePin, useMain } from '@/hooks';
import { appBarState } from '@/store/main/reducer';

interface MainViewProps {
    primaryColor: string;
    resetReducer: () => void;
    storeState: appBarState;
}

const MainView = ({ resetReducer, storeState }: MainViewProps) => {
    
    const { handleLogout } = useLogout(resetReducer, storeState);

    const errorProps = {
        subtitle: 'No tienes permiso para acceder a esta información',
        textButton: 'Aceptar',
        handleClick: handleLogout,
    };

    const { handleClickCard, evaluaciones, page, handleChange, notFound } = useMain();

    const { isTouchDevice } = useIsTouchDevice();

    const { pinValue, handlePinValue, status, surveytoken, handleGoBack, loading } = usePin();

    if (surveytoken !== null) {
        return (
            <TokenAuth
                handleReset={handleGoBack}
                loading={loading}
                status={status}
                pinValue={pinValue}
                handlePinValue={handlePinValue}
            />
        );
    }

    if (!evaluaciones) {
        console.log('2');
        return <SurveyLayout>{notFound ? <ErrorMessage {...errorProps} /> : <Loading />}</SurveyLayout>;
    }

    // EvaluacionAsignada
    const evaluacionesCount = evaluaciones.length;
    const evaluacionesPagination = Math.ceil(evaluacionesCount / 5);
    const evaluacionCountPage = (page - 1) * 5;

	console.log('EVALUACIONES');
	console.log(evaluaciones);

    return (
        <div
            className={`flex flex-col w-full h-full ${isTouchDevice ? 'p-0' : 'px-[10%] py-4 pb-5'}`}
        >
            <div
                className={`
                    flex flex-col p-[5%] bg-default-100 z-1
                    shadow-[rgba(99,99,99,0.2)_0px_2px_8px_0px]
                    ${isTouchDevice ? 'rounded-none h-full' : 'rounded min-h-100'}
                    border-default-300 border-x-35
                `}
                // style={{
                //     borderRight: `35px solid `,
                //     borderLeft: `35px solid ${primaryColor}`,
                // }}
            >
                <div className={isTouchDevice ? 'pb-6' : 'pb-4'}>
                    <h2 className={isTouchDevice ? 'text-3xl font-bold' : 'text-xl font-bold'}>Encuestas</h2>
                </div>
				{(evaluaciones || []).slice(evaluacionCountPage, evaluacionCountPage + 5).map((item, i) => {

                    return (
                        <SurveyCard isTouchDevice={isTouchDevice} handleClick={handleClickCard} key={i} item={item} />
                    );
                })}
                {evaluaciones.length > 5 && (
                    <div className="pt-2.5">
                        <Pagination
                            page={page}
                            onChange={(newPage) => handleChange({} as React.ChangeEvent<unknown>, newPage)}
                            total={evaluacionesPagination}
                            variant="bordered"
                            showControls
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default MainView;
